import React, { useState, useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useQuery from "../../Component/devDashboard2/common/useQuery";
import { AuthContext } from "../../context/auth-context";
import {
  fetchCustomerLlms,
  getMarkets,
  getCustomerMonitoringFiletrs,
} from "../../services/apiService";

import EmptyView from "../../Component/EmptyView/EmptyView";
import Spinner from "../../Component/Spinner/Spinner";
import classes from "./Conversations.module.css";

import DashboardNav from "./Form";
import api from "../../BrandOnBoarding/api";
import { useRef } from "react";
import GenericTable from "../../Component/BuyingJourneyDataTable/GenericTable";
import {
  sanitizeObject,
  transformFunnelData,
} from "../../utils/helpers";
import History from "./History/History";
import useHistory from "./History/useHistory";
import Form from "./DiscoveryForm";
import SnippetModal from "./SnippetModal";
import Share from "./Share/Share";
import { useReactToPrint } from "react-to-print";
import { faDownload } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Box, Button } from "@mui/material";
import { useDailyLimits } from "../../hooks/useDailyLimits";
import Header from "../../Component/Header/Header";
import PdfFilterModal from "./PdfFilterModal";
import MUIIconButton from "../../Component/UI/MUIIconButton/MUIIconButton";
import MUISelect from "../../Component/UI/MUISelect/MUISelect";
import { ENTITY_LABELS, mapLabel } from "../../utils/labelMapping";
import ConversationsReportingModal from "./Reporting/ConversationsReportingModal";
import SummarizeOutlinedIcon from "@mui/icons-material/SummarizeOutlined";

const CONTENT_TYPES = [
  { id: 1, name: "Reach" },
  { id: 1, name: "Sentiment" },
];

const Conversations = (props) => {

  const {
    launchText,
    hoverText,
    updateLaunches,
    launchesRemaining,
    isSpecial,
    frequency: launchLimitFrequency,
  } = useDailyLimits("Conversation");

  const [selectedOptionShow, setSelectedOptionShow] = useState("Company/Brand");
  const value = 0;

  const [showData, setShowData] = useState(false);
  const [isDone, setIsDone] = useState(true);
  const [selectedLlmItems, setSelectedLlmItems] = useState([]);
  const [selectedContentMapLlmItems, setSelectedContentMapLlmItems] = useState(
    []
  );
  const [contentMapLlm, setContentMapLlm] = useState();
  const [selectedMarketItems, setSelectedMarketItems] = useState([]);
  const [selectedGeographyItems, setSelectedGeographyItems] = useState([]);
  const [dbLlms, setDbLlms] = useState([]);
  const selectedFrequencyItems = ["Daily"];

  const [brandItems, setBrandItems] = useState([]);
  const [productItems, setProductItems] = useState([]);
  const [selectedBrandItems, setSelectedBrandItems] = useState([]);
  const [selectedProductItems, setSelectedProductItems] = useState([]);
  const [isDiscovery, setIsDiscovery] = useState(false);

  const [personas, setPersonas] = useState([]);
  const [selectedPersona, setSelectedPersona] = useState([]);

  const [customerLlm, setCustomerLlm] = useState([]);
  const [markets, setMarkets] = useState([]);
  const [geography, setGeography] = useState([]);

  const [selectedInputIds, setSelectedInputIds] = useState();

  const [focusAreaInputs, setFocusAreaInputs] = useState(null);

  const [contentMapData, setContentMapData] = useState([]);
  const [monitoringFiletrs, setMonitoringFilters] = useState();
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedCategoryIds, setSelectedCategoryIds] = useState(null);
  const [inputValues, setInputValues] = useState({})
  const [discoveryType, setDiscoveryType] = useState("brand")
  const [activeTab, setActiveTab] = useState("Monitoring");
  const [monitoringFiltersLoaded, setMonitoringFiltersLoaded] = useState(false);
  const didSetDefaultTabRef = useRef(false);
  const [selectedSiteSuggestions, setSelectedSiteSuggestions] = useState([]);
  const [discoveryInitialValues, setDiscoveryInitialValues] = useState({});
  const [currentHistoryId, setCurrentHistoryId] = useState(null);
  const [currentEntity, setCurrentEntity] = useState("");
  const [excludeBrandOwnedSources, setExcludeBrandOwnedSources] = useState(false);

  // Background job tracking
  const PENDING_JOB_KEY = 'conversations_pending_job';
  const [pendingJob, setPendingJob] = useState(() => {
    try { return JSON.parse(localStorage.getItem(PENDING_JOB_KEY)) || null; } catch { return null; }
  });

  const savePendingJob = (job) => {
    setPendingJob(job);
    if (job) localStorage.setItem(PENDING_JOB_KEY, JSON.stringify(job));
    else localStorage.removeItem(PENDING_JOB_KEY);
  };

  const [selectedQueryTypes, setSelectedQueryTypes] = useState(['brand']);
  const [resultQueryType, setResultQueryType] = useState('both');
  const [pendingCount, setPendingCount] = useState(0);
  const queryType = selectedQueryTypes.includes('brand') && selectedQueryTypes.includes('category')
    ? 'both'
    : selectedQueryTypes.includes('category') ? 'category' : 'brand';
  const handleQueryTypesChange = (selected) => {
    const values = selected?.map(opt => opt.value) || [];
    if (values.length === 0) return; // keep at least one selected
    setSelectedQueryTypes(values);
  };

  // PDF related states
  const [showPdfFilterModal, setShowPdfFilterModal] = useState(false);
  const [pdfFilterOption, setPdfFilterOption] = useState('');
  const [tableFilter, setTableFilter] = useState('brand');
  const [reportingModalOpen, setReportingModalOpen] = useState(false);

  const pdfRef = useRef();

  const exportToPDF = useReactToPrint({
    contentRef: pdfRef,
    documentTitle: `${isDiscovery ? discoveryInitialValues?.brand : selectedBrandItems?.[0] || selectedProductItems?.[0]} Conversations - ${pdfFilterOption.charAt(0).toUpperCase() + pdfFilterOption.slice(1)}`,
    removeAfterPrint: true,
    pageStyle: `
      @page {
        size: A4;
        margin: 10mm;
      }
      
      @media print {
        body {
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
          margin: 0;
          padding: 0;
        }
        
        * {
          box-sizing: border-box;
        }
        
        h1, h2, h3, h4, h5, h6 {
          page-break-after: avoid !important;
          break-after: avoid !important;
          page-break-inside: avoid !important;
          break-inside: avoid !important;
          margin: 4px 0 !important;
          padding: 0 !important;
        }
        
        h1 + div,
        div:has(h1) {
          page-break-after: avoid !important;
          break-after: avoid !important;
        }
        
        table {
          page-break-inside: auto;
          break-inside: auto;
          width: 100%;
          border-collapse: collapse;
          margin: 0 !important;
        }
        
        tr {
          page-break-inside: avoid;
          break-inside: avoid;
        }
        
        thead {
          display: table-header-group;
        }
        
        .MuiCard-root {
          page-break-inside: avoid;
          break-inside: avoid;
          margin: 4px 0 !important;
          padding: 0 !important;
          box-shadow: none !important;
          border: 1px solid #e0e0e0 !important;
        }
        
        .MuiCardContent-root {
          padding: 4px !important;
        }
        
        .MuiTableContainer-root {
          box-shadow: none !important;
          margin: 0 !important;
        }
        
        .MuiTableCell-root {
          padding: 3px 5px !important;
          font-size: 9px !important;
          line-height: 1.2 !important;
        }
        
        .MuiTableCell-head {
          padding: 5px !important;
          font-size: 10px !important;
          font-weight: 600 !important;
        }
        
        .MuiTypography-root {
          margin: 3px 0 !important;
          padding: 0 !important;
        }
        
        p {
          margin: 2px 0 !important;
          orphans: 2;
          widows: 2;
        }
        
        a {
          color: #1976d2;
          text-decoration: none;
          word-break: break-all;
          font-size: 8px !important;
        }
        
        .MuiStack-root {
          margin: 0 !important;
          padding: 0 !important;
          gap: 2px !important;
        }
      }
    `,
  });


  const query = useQuery();
  const { id: historyId } = useParams();

  const frequency = query.get("dateRange");

  const [selectedSubFrequencyItems, setSelectedSubFrequencyItems] = useState(
    frequency || "Current"
  );

  const dispatch = useDispatch();
  const brandProducts = useSelector((state) => state.brandProducts);
  const brands = useSelector((state) => state.brands);

  const { user, authUserEmail } = useContext(AuthContext);

  const { addHistory } = useHistory(authUserEmail);

  // Once the pending card appears in history, the submit window is over — clear loading flag
  useEffect(() => {
    if (discussionTopicsLoading) {
      setDiscussionTopicsLoading(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingCount]);

  // Poll for background job completion every 15s
  useEffect(() => {
    if (!pendingJob?.historyId) return;
    const check = async () => {
      try {
        const res = await api.get(`/users/content-map-history/${pendingJob.historyId}`);
        const data = res?.data?.data;
        if (!data) return;
        const status = data?.json_data?.status;
        if (status === 'completed') {
          savePendingJob(null);
          remountChild();
          toast.success(
            <span>
              Analysis for <strong>{data.entity}</strong> is ready.{' '}
              <Button size="small" variant="text" sx={{ p: 0, minWidth: 0, fontWeight: 700 }}
                onClick={() => updateStatesFromHistory(data)}>
                View
              </Button>
            </span>,
            { autoClose: false, closeOnClick: false }
          );
        } else if (status === 'failed') {
          savePendingJob(null);
          remountChild();
          toast.error(`Analysis for "${data.entity}" failed. Please try again.`);
        } else if (status === 'cancelled') {
          savePendingJob(null);
          remountChild();
        }
      } catch (_) {}
    };
    check();
    const interval = setInterval(check, 15000);
    return () => clearInterval(interval);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingJob?.historyId]);

  const customerId = user?.customer_id || 0;
  const isDemoAvailable = !!user?.is_demo_available;
  const [demoMode, setDemoMode] = useState(
    () => sessionStorage.getItem("conversationsDemoMode") === "true"
  );
  const effectiveCustomerId = demoMode ? 27 : customerId;

  const handleDemoModeChange = (checked) => {
    sessionStorage.setItem("conversationsDemoMode", String(checked));
    window.location.reload();
  };

  const isMonitoringEmpty = !demoMode && monitoringFiltersLoaded && !(monitoringFiletrs?.brands?.length > 0) && !(monitoringFiletrs?.products?.length > 0);

  // content data apis and states

  const [discussionTopics, setDiscussionTopics] = useState(null);

  const [discussionTopicsLoading, setDiscussionTopicsLoading] = useState(false);
  const [childKey, setChildKey] = useState(0);

  const remountChild = () => {
    setChildKey((prev) => prev + 1);
  };

  const [error, setError] = useState();

  const handleCancelRequest = async (historyId) => {
    const targetId = historyId || pendingJob?.historyId;
    if (!targetId) return;
    try {
      await api.post(`/metrics/purchase-journey-cancel/${targetId}`);
      await api.delete(`/users/content-map-history/${targetId}`);
      if (pendingJob?.historyId === targetId || pendingJob?.historyId === String(targetId)) {
        savePendingJob(null);
      }
      remountChild();
    } catch {
      toast.error('Failed to cancel analysis.');
    }
  };



  const fetchAllMetrics = async (payload, additionalHistoryData = {}) => {
    setError(null);
    const { entity, type, category } = payload;
    const { persona, location, market, siteSuggestions, moduleType } = additionalHistoryData;

    setDiscussionTopicsLoading(true);
    try {
      const response = await api.post('/metrics/purchase-journey-data-async', {
        ...payload,
        userEmail: authUserEmail,
        market,
        moduleType,
        siteSuggestions,
        queryType,
      });
      const { historyId } = response.data;
      savePendingJob({ historyId, entity, type, category, queryType });
      toast.info(
        `Analysis for "${entity}" is running in the background. You'll be notified when it's ready.`,
        { autoClose: 6000 }
      );
      remountChild();
    } catch (err) {
      toast.error(err?.response?.data?.error || err.message || 'Failed to start analysis');
      setError({ entity_discussion_topics: err.message });
      setDiscussionTopicsLoading(false);
    }
    // Success path: loading stays true until pendingCount updates (history card confirmed loaded)
  };



  const handleDiscussionTopics = async (values) => {
    const {
      category: dCategory,
      persona: dPersona,
      geography: dGeography,
      brand: dBrand,
      siteSuggestions: dSiteSuggestions,
      market: dMarket,
      excludeBrandOwnedSources: dExcludeBrandOwnedSources,
    } = values || {};

    const category = isDiscovery ? dCategory : selectedCategory?.[0];
    const persona = isDiscovery ? dPersona : selectedPersona?.[0] || "General Profile";
    const location = isDiscovery ? dGeography : selectedGeographyItems?.[0];
    const market = isDiscovery ? dMarket : selectedMarketItems?.[0];
    const entity = isDiscovery
      ? dBrand
      : selectedBrandItems?.[0] || selectedProductItems?.[0];

    const type = isDiscovery
      ? discoveryType
      : selectedOptionShow === "Product"
        ? "product"
        : "brand";

    const excludeFlag = isDiscovery ? dExcludeBrandOwnedSources : excludeBrandOwnedSources;

    const payload = {
      llm: "gpt-4o",
      category,
      type,
      persona: persona || 'General Profile',
      location: location || 'Global',
      entity,
      excludeBrandOwnedSources: excludeFlag,
    };

    // Add site suggestions parameters if any option is selected
    const siteSuggestions = isDiscovery ? dSiteSuggestions : selectedSiteSuggestions;
    if (siteSuggestions && siteSuggestions.length > 0) {
      payload.searchProvider = "grok";
      payload.targetDomains = siteSuggestions;
    }

    if (!category || !entity) {
      toast.warn(`${mapLabel(selectedOptionShow)} or Category is missing !`)
      return
    }

    try {
      await fetchAllMetrics(payload, {
        persona,
        location,
        market,
        siteSuggestions,
        moduleType: isDiscovery ? 'discovery' : 'monitoring'
      });
      if (launchesRemaining == 0 && !isSpecial) {
        toast.warn(
          `You have reached your ${launchLimitFrequency} limit`
        );
        return;
      }
      if (!isSpecial) updateLaunches();
    } catch (error) {
      console.error("Error fetching metrics:", error);
    }
  };


  useEffect(() => {
    async function fetchData() {
      const selectedBrandCustomerId =
        query.get("brandCustomerId") || customerId;
      const customerSpecificLlms = await fetchCustomerLlms([
        Number(selectedBrandCustomerId),
      ]);

      setCustomerLlm(customerSpecificLlms?.data);
      const inputFilters = await getCustomerMonitoringFiletrs(effectiveCustomerId);

      // Deep copy to avoid mutation if needed (e.g., structuredClone or JSON approach)
      let filters = {
        ...inputFilters,
        brands: [...(inputFilters?.brands || [])],
        products: [...(inputFilters?.products || [])],
      };

      setMonitoringFilters(filters);

      if (!didSetDefaultTabRef.current) {
        didSetDefaultTabRef.current = true;
        const hasMonitoringData =
          demoMode || filters?.brands?.length > 0 || filters?.products?.length > 0;
        if (!hasMonitoringData) {
          setActiveTab("Discovery");
          setIsDiscovery(true);
        }
      }
      setMonitoringFiltersLoaded(true);

      if (selectedOptionShow === "Company/Brand") {
        const llms = filters?.brands?.[0]?.categories?.[0]?.llms;

        let llmFromQuery = llms?.[0]?.name;

        const markets = filters?.brands?.[0]?.categories?.[0]?.markets;
        let marketFromQuery = markets?.[0]?.name;

        const geography = filters?.brands?.[0]?.categories?.[0]?.geographies;

        let geoFromQuery = geography?.[0]?.name;

        const persona = filters?.brands?.[0]?.categories?.[0]?.personas;
        const category = filters?.brands?.[0]?.categories?.map((item) => {
          return { id: item?.categoryId, name: item?.categoryName };
        });

        const categoryIds = [category?.[0]?.id] || null;

        setDbLlms(llms);
        setMarkets(markets);
        setGeography(geography);

        setSelectedBrandItems([filters?.brands?.[0]?.brand_name]);
        setSelectedPersona([persona?.[0]?.name]);
        setSelectedLlmItems([llmFromQuery]);
        setSelectedMarketItems([marketFromQuery]);
        setSelectedGeographyItems([geoFromQuery]);
        setBrandItems(
          filters?.brands?.map((item) => {
            return { id: item?.customer_brand_id, name: item?.brand_name };
          })
        );
        setPersonas(persona);
        setCategories(category);
        setSelectedCategory([category?.[0]?.name]);
        setSelectedCategoryIds(categoryIds);
      }

      if (selectedOptionShow === "Product") {
        console.log("test==>", filters);
        const geography = filters?.products?.[0]?.categories?.[0]?.geographies;
        const markets = filters?.products?.[0]?.categories?.[0]?.markets;
        const persona = filters?.products?.[0]?.categories?.[0]?.personas;
        const llms = filters?.products?.[0]?.categories?.[0]?.llms;
        const category = filters?.products?.[0]?.categories?.map((item) => {
          return { id: item?.categoryId, name: item?.categoryName };
        });
        const categoryIds = [category?.[0]?.id] || null;

        setDbLlms(llms);
        setGeography(geography);
        setMarkets(markets);
        setSelectedProductItems([filters?.products?.[0]?.product_name]);
        setSelectedPersona([persona?.[0]?.name]);
        setSelectedLlmItems([llms?.[0]?.name]);
        setSelectedMarketItems([markets?.[0]?.name]);
        setSelectedGeographyItems([geography?.[0]?.name]);
        setProductItems(
          filters?.products?.map((item) => {
            return {
              id: item?.customer_brand_product_id,
              name: item?.product_name,
            };
          })
        );
        setPersonas(persona);
        setCategories(category);
        setSelectedCategory([category?.[0]?.name]);
        setSelectedCategoryIds(categoryIds);
      }
    }

    fetchData();
  }, [selectedOptionShow]);

  useEffect(() => {
    async function fetchCustomerLlmsData() {
      if (selectedProductItems && selectedProductItems.length > 0) {
        if (selectedOptionShow === "Product") {
          const geography = monitoringFiletrs?.products
            ?.filter((item) =>
              selectedProductItems.includes(item?.product_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.geographies;
          const markets = monitoringFiletrs?.products
            ?.filter((item) =>
              selectedProductItems.includes(item?.product_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.markets;
          const persona = monitoringFiletrs?.products
            ?.filter((item) =>
              selectedProductItems.includes(item?.product_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.personas;
          const llms = monitoringFiletrs?.products
            ?.filter((item) =>
              selectedProductItems.includes(item?.product_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.llms;
          const category = monitoringFiletrs?.products
            ?.filter((item) =>
              selectedProductItems?.includes(item?.product_name)
            )?.[0]
            ?.categories?.map((item) => {
              return { id: item?.categoryId, name: item?.categoryName };
            });
          const categoryIds = [category?.[0]?.id] || null;
          setSelectedCategoryIds(categoryIds);
          setDbLlms(llms);
          setGeography(geography);
          setMarkets(markets);
          setPersonas(persona);
          setCategories(category);
          setSelectedLlmItems([llms?.[0]?.name]);
          setSelectedMarketItems([markets?.[0]?.name]);
          setSelectedGeographyItems([geography?.[0]?.name]);
          setSelectedPersona([persona?.[0]?.name]);
          setSelectedCategory([category?.[0]?.name]);
        }
      }
    }

    fetchCustomerLlmsData();
  }, [selectedProductItems]);

  useEffect(() => {
    async function fetchCustomerLlmsData() {
      if (selectedBrandItems && selectedBrandItems.length > 0) {
        if (selectedOptionShow === "Company/Brand") {
          const geography = monitoringFiletrs?.brands?.filter((item) =>
            selectedBrandItems.includes(item?.brand_name)
          )?.[0]?.categories?.[0]?.geographies;
          const markets = monitoringFiletrs?.brands?.filter((item) =>
            selectedBrandItems.includes(item?.brand_name)
          )?.[0]?.categories?.[0]?.markets;
          const persona = monitoringFiletrs?.brands?.filter((item) =>
            selectedBrandItems.includes(item?.brand_name)
          )?.[0]?.categories?.[0]?.personas;
          const llms = monitoringFiletrs?.brands?.filter((item) =>
            selectedBrandItems.includes(item?.brand_name)
          )?.[0]?.categories?.[0]?.llms;
          const category = monitoringFiletrs?.brands
            ?.filter((item) =>
              selectedBrandItems?.includes(item?.brand_name)
            )?.[0]
            ?.categories?.map((item) => {
              return { id: item?.categoryId, name: item?.categoryName };
            });
          const categoryIds = [category?.[0]?.id] || null;
          setSelectedCategoryIds(categoryIds);

          setDbLlms(llms);
          setGeography(geography);
          setMarkets(markets);
          setPersonas(persona);
          setCategories(category);
          setSelectedLlmItems([llms?.[0]?.name]);
          setSelectedMarketItems([markets?.[0]?.name]);
          setSelectedGeographyItems([geography?.[0]?.name]);
          setSelectedPersona([persona?.[0]?.name]);
          setSelectedCategory([category?.[0]?.name]);
        }
      }
    }

    fetchCustomerLlmsData();
  }, [selectedBrandItems]);

  useEffect(() => {
    async function fetchCustomerLlmsData() {
      if (selectedCategory && selectedCategory.length > 0) {
        if (
          selectedProductItems?.length !== 0 &&
          selectedOptionShow === "Product"
        ) {
          const geography = monitoringFiletrs?.products
            ?.filter((item) =>
              selectedProductItems.includes(item?.product_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.geographies;
          const markets = monitoringFiletrs?.products
            ?.filter((item) =>
              selectedProductItems.includes(item?.product_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.markets;
          const persona = monitoringFiletrs?.products
            ?.filter((item) =>
              selectedProductItems.includes(item?.product_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.personas;
          const llms = monitoringFiletrs?.products
            ?.filter((item) =>
              selectedProductItems.includes(item?.product_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.llms;

          setDbLlms(llms);
          setGeography(geography);
          setMarkets(markets);
          setPersonas(persona);
        }

        if (
          selectedBrandItems?.length !== 0 &&
          selectedOptionShow === "Company/Brand"
        ) {
          const geography = monitoringFiletrs?.brands
            ?.filter((item) =>
              selectedBrandItems.includes(item?.brand_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.geographies;
          const markets = monitoringFiletrs?.brands
            ?.filter((item) =>
              selectedBrandItems.includes(item?.brand_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.markets;
          const persona = monitoringFiletrs?.brands
            ?.filter((item) =>
              selectedBrandItems.includes(item?.brand_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.personas;
          const llms = monitoringFiletrs?.brands
            ?.filter((item) =>
              selectedBrandItems.includes(item?.brand_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.llms;

          setDbLlms(llms);
          setGeography(geography);
          setMarkets(markets);
          setPersonas(persona);
        }
      }
    }

    fetchCustomerLlmsData();
  }, [selectedCategory]);

  // Load history item from URL parameter
  useEffect(() => {
    async function loadHistoryFromUrl() {
      if (historyId) {
        try {
          const response = await api.get(`/users/content-map-history/${historyId}`);
          if (response?.data?.data) {
            updateStatesFromHistory(response.data?.data);
          }
        } catch (error) {
          console.error("Error loading history:", error);
          toast.error("Failed to load shared conversation.");
        }
      }
    }

    loadHistoryFromUrl();
  }, [historyId]);

  const handleLlmCheckChange = (selected) => {
    const selectedValues = selected?.map((option) => option?.name) || [];

    setSelectedLlmItems(selectedValues.at(-1) ? [selectedValues.at(-1)] : []);
  };

  const handleCategoryCheckChange = (selected) => {
    if (!selected || selected.length === 0) {
      setSelectedCategory([]);
      setSelectedCategoryIds([]);
      return;
    }

    const lastSelected = selected[selected.length - 1];
    setSelectedCategory([lastSelected.name]);
    setSelectedCategoryIds([lastSelected.id]);
  };



  const handlesubFrequencyCheckChange = (key) => {
    setSelectedSubFrequencyItems(key);
  };

  const handleMarketCheckChange = (selected) => {
    let selectedValues = selected?.map((option) => option?.name);
    let lastIndex = selectedValues.length - 1;
    selectedValues = selectedValues?.filter(
      (item, index) => index === lastIndex
    );

    setSelectedMarketItems(selectedValues || []);
  };

  const handleGeographyCheckChange = async (selected) => {
    let selectedValues = selected?.map((option) => option?.name);
    let lastIndex = selectedValues.length - 1;
    selectedValues = selectedValues?.filter(
      (item, index) => index === lastIndex
    );
    const latestValue = selectedValues[selectedValues.length - 1];
    setSelectedGeographyItems(selectedValues || []);

    let geoId = geography.filter((obj) => obj?.name === latestValue)[0]?.id;
    let market = await getMarkets();
    const filtercustomeLlm = customerLlm.filter(
      (obj) => obj?.geography_id === geoId
    );

    if (selectedValues && selectedValues.length === 1) {
      // set customer geography markets

      const marketIds = [
        ...new Set(filtercustomeLlm.map((obj) => obj?.market_id)),
      ];
      market = market?.data.filter((obj) => marketIds.includes(obj?.id));
      setMarkets(market);
    } else if (selectedValues && selectedValues.length > 1) {
      // set customer geography markets

      market = market?.data.filter((obj) => obj?.name === "General Market");
      setMarkets(market);
    }
  };

  const handleProductCheckChange = (selected) => {
    let selectedValues = selected?.map((option) => option?.name);
    let lastIndex = selectedValues.length - 1;
    selectedValues = selectedValues?.filter(
      (item, index) => index === lastIndex
    );

    setSelectedProductItems(selectedValues || []);
  };

  const handleBrandCheckChange = (selected) => {
    let selectedValues = selected?.map((option) => option?.name);
    let lastIndex = selectedValues.length - 1;
    selectedValues = selectedValues?.filter(
      (item, index) => index === lastIndex
    );

    setSelectedBrandItems(selectedValues || []);
  };

  const handlePersonaCheckChange = (selected) => {
    const selectedValues = selected?.map((option) => option?.name);
    let lastIndex = selectedValues.length - 1;
    const lastSelectedValue = selectedValues?.filter(
      (item, index) => index === lastIndex
    );
    setSelectedPersona(lastSelectedValue || []);
  };

  const handleSiteSuggestionsCheckChange = (selected) => {
    const selectedValues = selected?.map((option) => option.value) || [];
    setSelectedSiteSuggestions(selectedValues);
  };




  const handleContentTypeChange = (selected) => {
    let selectedValues = selected?.map((option) => option?.name);
    let lastIndex = selectedValues.length - 1;
    selectedValues = selectedValues?.filter(
      (item, index) => index === lastIndex
    );

    setShowData(false);
  };

  const updateStatesFromHistory = (data) => {
    const jobStatus = data?.json_data?.status;
    if (jobStatus === 'pending') {
      toast.info('This analysis is still running in the background. You\'ll be notified when it\'s ready.');
      return;
    }
    if (jobStatus === 'failed') {
      toast.error('This analysis failed. Please run it again.');
      return;
    }
    if (jobStatus === 'cancelled') {
      toast.info('This analysis was cancelled.');
      return;
    }
    const resultQueryType = data?.json_data?.queryType || 'both';
    setResultQueryType(resultQueryType);
    setTableFilter(resultQueryType === 'brand' ? 'brand' : resultQueryType === 'category' ? 'category' : 'both');
    setContentMapData(data?.json_data?.data);
    setDiscussionTopics(data?.json_data?.discussionTopics);
    setFocusAreaInputs(data?.json_data?.focusAreaInputs);
    setShowData(true);
    setIsDone(true);

    console.log('state==>', data, data?.json_data);

    // Set current history ID and entity for sharing
    setCurrentHistoryId(data?.id);
    setCurrentEntity(data?.entity || "");

    // Restore query type checkboxes
    const historyQueryType = data?.json_data?.queryType || 'brand';
    setSelectedQueryTypes(
      historyQueryType === 'both' ? ['brand', 'category'] :
      historyQueryType === 'category' ? ['category'] : ['brand']
    );

    // Restore additional fields from history
    const { persona, location, market, siteSuggestions, moduleType, type, category, excludeBrandOwnedSources: savedExclude } = data?.json_data || {};

    // Default to 'discovery' for backward compatibility with old data
    const effectiveModuleType = moduleType || 'discovery';

    // Set module type (discovery or monitoring)
    if (effectiveModuleType === 'discovery') {
      setIsDiscovery(true);
      setActiveTab('Discovery');

      // Set discovery initial values for the form
      setDiscoveryInitialValues({
        brand: data?.entity || "",
        category: category || "",
        persona: persona || "General Profile",
        geography: location || "Global",
        market: market || "",
        siteSuggestions: siteSuggestions || [],
        excludeBrandOwnedSources: savedExclude || false,
      });

      // Set discovery type
      if (type === 'product') {
        setDiscoveryType('product');
      } else {
        setDiscoveryType('brand');
      }
    } else if (effectiveModuleType === 'monitoring') {
      setIsDiscovery(false);
      setActiveTab('Monitoring');

      // Restore entity type (brand or product)
      if (type === 'product') {
        setSelectedOptionShow('Product');
        if (data?.entity) {
          setSelectedProductItems([data.entity]);
        }
      } else if (type === 'brand') {
        setSelectedOptionShow('Company/Brand');
        if (data?.entity) {
          setSelectedBrandItems([data.entity]);
        }
      }

      // Restore other fields for monitoring mode with defaults
      if (persona) {
        setSelectedPersona([persona]);
      } else {
        setSelectedPersona(["General Profile"]);
      }

      if (location) {
        setSelectedGeographyItems([location]);
      } else {
        setSelectedGeographyItems(["Global"]);
      }

      if (market) {
        setSelectedMarketItems([market]);
      }

      if (category) {
        setSelectedCategory([category]);
      }

      if (siteSuggestions && siteSuggestions.length > 0) {
        setSelectedSiteSuggestions(siteSuggestions);
      }

      setExcludeBrandOwnedSources(savedExclude || false);
    }
  };

  if (
    selectedOptionShow === "Product" &&
    brandProducts?.data?.data &&
    !brandProducts?.data?.data.length
  ) {
    return <EmptyView message="No Products Found" />;
  }

  const transformDiscussionData = (arr) => {
    if (!arr || arr.length === 0) return;

    return arr.map((obj) => {
      const mainKey = Object.keys(obj).find(
        (k) => k !== "rating" && k !== "explanation" && k !== "sources"
      );

      return {
        // [mainKey]: `${obj?.[mainKey]}-${obj?.rating}`,
        [mainKey]: `${obj?.[mainKey]}`,
        explanation: obj?.explanation,
        sources: obj?.sources || [], // Preserve sources if they exist, otherwise empty array
      };
    });
  };

  // PDF Filter Options
  const pdfFilterOptions = [
    { name: `${mapLabel(selectedOptionShow)} Tables Only`, value: mapLabel(selectedOptionShow).toLowerCase() },
    { name: 'Category Tables Only', value: 'category' },
    { name: `Both ${mapLabel(selectedOptionShow)} and Category`, value: 'both' }
  ];

  const tableFilterOptions = [
    { name: mapLabel(selectedOptionShow), value: 'brand' },
    { name: 'Category', value: 'category' },
    { name: 'Both', value: 'both' },
  ].filter(opt => {
    if (resultQueryType === 'brand') return opt.value === 'brand';
    if (resultQueryType === 'category') return opt.value === 'category';
    return true;
  });

  // Get type label
  const type = selectedOptionShow === "Product" ? ENTITY_LABELS.product : ENTITY_LABELS.brand;

  // Tables configuration for PDF
  const tablesConfig = [
    // Brand Discussion Topics
    {
      id: "Brand_Discussion_Topics",
      title: `${type} Discussion Topics`,
      data: discussionTopics?.discussionTopics?.entity_discussion_topics,
      sources: discussionTopics?.discussionTopics?.entity_discussion_topics_sources,
      rawData: discussionTopics?.rawData?.discussionTopics?.entity?.results,
      rawSearchData: discussionTopics?.discussionTopics?.entityRawSearch,
      isBrandTable: true,
    },
    // Category Discussion Topics
    {
      id: "Category_Discussion_Topics",
      title: "Category Discussion Topics",
      data: discussionTopics?.discussionTopics?.discussion_topics,
      sources: discussionTopics?.discussionTopics?.discussion_topics_sources,
      rawData: discussionTopics?.rawData?.discussionTopics?.category?.results,
      rawSearchData: discussionTopics?.discussionTopics?.categoryRawSearch,
      isBrandTable: false,
    },
    // Brand Key Questions
    {
      id: "Brand_Key_Questions",
      title: `${type} Key Questions`,
      data: discussionTopics?.keyQuestions?.entity_key_questions,
      sources: discussionTopics?.keyQuestions?.entity_key_questions_sources || discussionTopics?.keyQuestions?.entity_key_question_sources,
      rawData: discussionTopics?.rawData?.keyQuestions?.entity?.results,
      rawSearchData: discussionTopics?.keyQuestions?.entityRawSearch,
      isBrandTable: true,
    },
    // Category Key Questions
    {
      id: "Category_Key_Questions",
      title: "Category Key Questions",
      data: discussionTopics?.keyQuestions?.key_questions,
      sources: discussionTopics?.keyQuestions?.key_questions_sources || discussionTopics?.keyQuestions?.key_question_sources,
      rawData: discussionTopics?.rawData?.keyQuestions?.category?.results,
      rawSearchData: discussionTopics?.keyQuestions?.categoryRawSearch,
      isBrandTable: false,
    },
    // Brand Purchase Barriers
    {
      id: "Brand_Purchase_Barriers",
      title: `${type} Purchase Barriers`,
      data: discussionTopics?.purchaseBarriers?.entity_data,
      sources: discussionTopics?.purchaseBarriers?.entity_data_sources,
      rawData: discussionTopics?.rawData?.purchaseBarriers?.entity?.results,
      rawSearchData: discussionTopics?.purchaseBarriers?.entityRawSearch,
      isBrandTable: true,
    },
    // Category Purchase Barriers
    {
      id: "Category_Purchase_Barriers",
      title: "Category Purchase Barriers",
      data: discussionTopics?.purchaseBarriers?.category_data,
      sources: discussionTopics?.purchaseBarriers?.category_data_sources,
      rawData: discussionTopics?.rawData?.purchaseBarriers?.category?.results,
      rawSearchData: discussionTopics?.purchaseBarriers?.categoryRawSearch,
      isBrandTable: false,
    },
    // Brand Purchase Enablers
    {
      id: "Brand_Purchase_Enablers",
      title: `${type} Purchase Enablers`,
      data: discussionTopics?.purchaseEnablers?.entity_data,
      sources: discussionTopics?.purchaseEnablers?.entity_data_sources,
      rawData: discussionTopics?.rawData?.purchaseEnablers?.entity?.results,
      rawSearchData: discussionTopics?.purchaseEnablers?.entityRawSearch,
      isBrandTable: true,
    },
    // Category Purchase Enablers
    {
      id: "Category_Purchase_Enablers",
      title: "Category Purchase Enablers",
      data: discussionTopics?.purchaseEnablers?.category_data,
      sources: discussionTopics?.purchaseEnablers?.category_data_sources,
      rawData: discussionTopics?.rawData?.purchaseEnablers?.category?.results,
      rawSearchData: discussionTopics?.purchaseEnablers?.categoryRawSearch,
      isBrandTable: false,
    },
    // Brand Customer Needs
    {
      id: "Brand_Customer_Needs",
      title: `${type} Customer Needs`,
      data: discussionTopics?.customerNeeds?.entity_customer_needs,
      sources: discussionTopics?.customerNeeds?.entity_customer_needs_sources,
      rawData: discussionTopics?.rawData?.customerNeeds?.entity?.results,
      rawSearchData: discussionTopics?.customerNeeds?.entityRawSearch,
      isBrandTable: true,
    },
    // Category Customer Needs
    {
      id: "Category_Customer_Needs",
      title: "Category Customer Needs",
      data: discussionTopics?.customerNeeds?.customer_needs,
      sources: discussionTopics?.customerNeeds?.customer_needs_sources,
      rawData: discussionTopics?.rawData?.customerNeeds?.category?.results,
      rawSearchData: discussionTopics?.customerNeeds?.categoryRawSearch,
      isBrandTable: false,
    },
    // Brand Customer Pain Points
    {
      id: "Brand_Customer_Pain_Points",
      title: `${type} Customer Pain Points`,
      data: discussionTopics?.customerPainPoints?.entity_customer_pain_points,
      sources: discussionTopics?.customerPainPoints?.entity_customer_pain_points_sources,
      rawData: discussionTopics?.rawData?.customerPainPoints?.entity?.results,
      rawSearchData: discussionTopics?.customerPainPoints?.entityRawSearch,
      isBrandTable: true,
    },
    // Category Customer Pain Points
    {
      id: "Category_Customer_Pain_Points",
      title: "Category Customer Pain Points",
      data: discussionTopics?.customerPainPoints?.customer_pain_points,
      sources: discussionTopics?.customerPainPoints?.customer_pain_points_sources,
      rawData: discussionTopics?.rawData?.customerPainPoints?.category?.results,
      rawSearchData: discussionTopics?.customerPainPoints?.categoryRawSearch,
      isBrandTable: false,
    },
    // Brand Emerging Trends
    {
      id: "Brand_Emerging_Trends",
      title: `${type} Emerging Trends`,
      data: discussionTopics?.customerEmergingTrends?.entity_emerging_trends,
      sources: discussionTopics?.customerEmergingTrends?.entity_emerging_trends_sources,
      rawData: discussionTopics?.rawData?.customerEmergingTrends?.entity?.results,
      rawSearchData: discussionTopics?.customerEmergingTrends?.entityRawSearch,
      isBrandTable: true,
    },
    // Category Emerging Trends
    {
      id: "Category_Emerging_Trends",
      title: "Category Emerging Trends",
      data: discussionTopics?.customerEmergingTrends?.emerging_trends,
      sources: discussionTopics?.customerEmergingTrends?.emerging_trends_sources,
      rawData: discussionTopics?.rawData?.customerEmergingTrends?.category?.results,
      rawSearchData: discussionTopics?.customerEmergingTrends?.categoryRawSearch,
      isBrandTable: false,
    },
    // Brand Customer Complaints
    {
      id: "Brand_Customer_Complaints",
      title: `${type} Customer Complaints`,
      data: discussionTopics?.customerComplaints?.entity_customer_complaints,
      sources: discussionTopics?.customerComplaints?.entity_customer_complaints_sources,
      rawData: discussionTopics?.rawData?.customerComplaints?.entity?.results,
      rawSearchData: discussionTopics?.customerComplaints?.entityRawSearch,
      isBrandTable: true,
    },
    // Brand Customer Praises
    {
      id: "Brand_Customer_Praises",
      title: `${type} Customer Praises`,
      data: discussionTopics?.customerPraises?.entity_customer_praises,
      sources: discussionTopics?.customerPraises?.entity_customer_praises_sources,
      rawData: discussionTopics?.rawData?.customerPraises?.entity?.results,
      rawSearchData: discussionTopics?.customerPraises?.entityRawSearch,
      isBrandTable: true,
    },
    // Brand Buying Journey Prompts
    {
      id: "Brand_Buying_Journey_Prompts",
      title: `${type} Buying Journey Prompts`,
      data: transformFunnelData(
        discussionTopics?.purchaseJourneyQuestions?.entity_questions?.questions_by_funnel_stage
      ),
      rawSearchData: discussionTopics?.purchaseJourneyQuestions?.entityRawSearch,
      isBrandTable: true,
    },
  ];

  const displayedTables = tableFilter === 'brand'
    ? tablesConfig.filter(t => t.isBrandTable)
    : tableFilter === 'category'
      ? tablesConfig.filter(t => !t.isBrandTable)
      : tablesConfig;

  // Filter tables based on selection
  const getFilteredTables = () => {
    if (pdfFilterOption === mapLabel(selectedOptionShow).toLowerCase()) {
      return tablesConfig.filter(table => table.isBrandTable);
    } else if (pdfFilterOption === 'category') {
      return tablesConfig.filter(table => !table.isBrandTable);
    } else if (pdfFilterOption === 'both') {
      const brandTables = tablesConfig.filter(table => table.isBrandTable);
      const categoryTables = tablesConfig.filter(table => !table.isBrandTable);
      return [...brandTables, ...categoryTables];
    }
    return [];
  };

  // PDF Handlers
  const handleDownloadClick = () => {
    setShowPdfFilterModal(true);
  };

  const handlePdfFilterChange = (e) => {
    setPdfFilterOption(e.target.value);
  };

  const handlePdfDownload = () => {
    setShowPdfFilterModal(false);
    setTimeout(() => {
      exportToPDF();
    }, 100);
  };

  const handlePdfModalClose = () => {
    setShowPdfFilterModal(false);
    setPdfFilterOption('');
  };

  function dynamicReplace(text) {
    let result = text;

    const replacements = {
      "Brand": ENTITY_LABELS.brand,
      "Product": ENTITY_LABELS.product,
      "Buying Journey": ENTITY_LABELS.buyingJourney,
      "Post-Purchase": ENTITY_LABELS.postPurchase,
      'Customer': ENTITY_LABELS.customer,
      "Purchase": ENTITY_LABELS.purchase,
    };

    Object.keys(replacements).forEach((key) => {
      const regex = new RegExp(key, "gi"); // case-insensitive
      result = result.replace(regex, replacements[key]);
    });

    return result;
  }

  const TableWrapper = ({
    data,
    title,
    loading,
    error,
    minWidth = "99%",
    sources,
    rawData,
    rawSearchData,
    isFirstPdfTable
  }) => {
    const [open, setOpen] = useState(false);
    return (
      <div className={classes.tablewrapper} style={{ flex: 1, minWidth }}>
        <GenericTable
          sources={sources}
          data={
            title === `${type} Buying Journey Prompts` ||
              title === "Category Buying Journey Prompts"
              ? data
              : transformDiscussionData(data)
          }
          loading={loading}
          title={dynamicReplace(title)}
          error={error}
          open={open}
          setOpen={setOpen}
          rawData={rawData}
          rawSearchData={rawSearchData}
          isFirstPdfTable={isFirstPdfTable}
        />
      </div>
    );
  }

  const handleClick = (target) => {
    setActiveTab(target);
    setDiscussionTopics(null);
    setShowData(false);
    setCurrentHistoryId(null);
    setCurrentEntity("");
  };

  if (!demoMode && !monitoringFiltersLoaded) {
    return (
      <div className="bodycontent" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '300px' }}>
        <Spinner size={36} />
      </div>
    );
  }

  return (
    <div className="bodycontent">


      <div style={{ display: 'flex', justifyContent: 'space-between' }} className="col-md-12">
        <div className="mb-3 w-100 d-flex justify-content-center align-items-center">
          <div style={{ border: "none" }} className="dmqGroup">
            {!isMonitoringEmpty &&
              <button
                className={activeTab === "Monitoring" ? "active" : ""}
                onClick={() => {
                  handleClick("Monitoring");
                  setIsDiscovery(false);
                }}
              >
                Monitoring
              </button>}

            &nbsp; &nbsp;
            <button
              className={activeTab === "Discovery" ? "active" : ""}
              onClick={() => {
                handleClick("Discovery");
                setIsDiscovery(true);
              }}
            >
              Discovery
            </button>
          </div>
        </div>
        <Header actionText={launchText} hoverText={hoverText} actionVariant="text" />
      </div>
      <div className={classes.section_summary}>
        {isDiscovery ? <div>  <Form handleClickShow={handleDiscussionTopics} discoveryType={discoveryType} setDiscoveryType={setDiscoveryType} setInputValues={setInputValues} initialValues={discoveryInitialValues} isLoading={discussionTopicsLoading || pendingCount >= 3} onCancel={handleCancelRequest} selectedQueryTypes={selectedQueryTypes} onQueryTypesChange={handleQueryTypesChange} isDemoMode={demoMode} /> </div> : <div>
          <DashboardNav
            contentTypes={CONTENT_TYPES}
            handleContentTypeChange={handleContentTypeChange}
            selectedOptionShow={selectedOptionShow}
            brandItems={brandItems}
            categories={categories}
            handleCategoryCheckChange={handleCategoryCheckChange}
            selectedCategory={selectedCategory}
            selectedBrandItems={selectedBrandItems}
            handleBrandCheckChange={handleBrandCheckChange}
            handleProductCheckChange={handleProductCheckChange}
            selectedProductItems={selectedProductItems}
            productItems={productItems}
            selectedPersona={selectedPersona}
            handlePersonaCheckChange={handlePersonaCheckChange}
            personas={personas}
            selectedGeographyItems={selectedGeographyItems}
            handleGeographyCheckChange={handleGeographyCheckChange}
            geography={geography}
            selectedMarketItems={selectedMarketItems}
            handleMarketCheckChange={handleMarketCheckChange}
            markets={markets}
            selectedLlmItems={selectedLlmItems}
            handleLlmCheckChange={handleLlmCheckChange}
            dbLlms={dbLlms}
            selectedSubFrequencyItems={selectedSubFrequencyItems}
            handlesubFrequencyCheckChange={handlesubFrequencyCheckChange}
            showData={showData}
            isDone={!discussionTopicsLoading && pendingCount < 3}
            isLoading={discussionTopicsLoading || pendingCount >= 3}
            onCancel={handleCancelRequest}
            handleClickShow={handleDiscussionTopics}
            setSelectedOptionShow={setSelectedOptionShow}
            selectedSiteSuggestions={selectedSiteSuggestions}
            handleSiteSuggestionsCheckChange={handleSiteSuggestionsCheckChange}
            excludeBrandOwnedSources={excludeBrandOwnedSources}
            handleExcludeBrandOwnedSourcesChange={(e) => setExcludeBrandOwnedSources(e.target.checked)}
            selectedQueryTypes={selectedQueryTypes}
            onQueryTypesChange={handleQueryTypesChange}
            isDemoMode={demoMode}
            noMonitoringData={isMonitoringEmpty}
          />
        </div>}
        <div className={` ${classes.history}`}>
          <History
            key={childKey}
            filter={selectedOptionShow === "Product" ? "product" : "brand"}
            updateStatesFromHistory={updateStatesFromHistory}
            onJobCancel={handleCancelRequest}
            isDemoAvailable={isDemoAvailable}
            demoMode={demoMode}
            onDemoModeChange={handleDemoModeChange}
            onPendingCountChange={setPendingCount}
          />
        </div>
      </div>

      <div>
        <>
          <br />
          <div>
            {discussionTopics !== null && (
              <>
                <hr />
                <div className={classes.exportBtn} style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                  <MUISelect
                    fullWidth={false}
                    optionValue={tableFilter}
                    label="Show Conversations For"
                    id="tableFilter"
                    options={tableFilterOptions}
                    onChange={(e) => setTableFilter(e.target.value)}
                  />
                  {currentHistoryId && (
                    <Share historyId={currentHistoryId} entityName={currentEntity} />
                  )}
                  <MUIIconButton
                    title="Download as PDF"
                    onClick={handleDownloadClick}
                    disabled={discussionTopicsLoading}
                    className={classes.downloadBtn}
                  >
                    <FontAwesomeIcon icon={faDownload} />
                  </MUIIconButton>
                  {currentHistoryId && user?.is_conversation_html_report_enabled && (
                    <MUIIconButton
                      title="Generate HTML Report"
                      onClick={() => setReportingModalOpen(true)}
                      disabled={discussionTopicsLoading}
                    >
                      <SummarizeOutlinedIcon color="primary" />
                    </MUIIconButton>
                  )}
                </div>
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "0.5rem",
                    "@media print": {
                      display: "block",
                      flexWrap: "unset",
                      gap: 0,
                    },
                  }}
                >
                  {displayedTables.map((table) => (
                    <TableWrapper
                      key={table.id}
                      {...table}
                      loading={discussionTopicsLoading}
                      minWidth={tableFilter === 'both' ? "49%" : "100%"}
                    />
                  ))}
                </Box>

                {/* Hidden PDF Content */}
                <div style={{ display: 'none' }}>
                  <div ref={pdfRef} style={{ width: '100%', maxWidth: '210mm', margin: '0 auto' }}>
                    <div style={{ padding: '8mm' }}>
                      {/* PDF Header */}
                      <div
                        style={{
                          pageBreakAfter: 'avoid',
                          breakAfter: 'avoid',
                          pageBreakInside: 'avoid',
                          breakInside: 'avoid',
                          marginBottom: '4px',
                          paddingBottom: '0',
                        }}
                      >
                        <h1
                          style={{
                            textAlign: 'center',
                            margin: '0 0 6px 0',
                            fontSize: '18px',
                            color: '#1f2937',
                            pageBreakAfter: 'avoid',
                            breakAfter: 'avoid'
                          }}
                        >
                          {pdfFilterOption === mapLabel(selectedOptionShow).toLowerCase() && `${mapLabel(selectedOptionShow)} Conversations Report`}
                          {pdfFilterOption === 'category' && 'Category Conversations Report'}
                          {pdfFilterOption === 'both' && `${mapLabel(selectedOptionShow)} and Category Conversations Report`}
                        </h1>

                        <div
                          style={{
                            margin: '0',
                            textAlign: 'center',
                            color: '#6b7280',
                            fontSize: '10px',
                            lineHeight: '1.3'
                          }}
                        >
                          <p style={{ margin: '2px 0' }}>
                            {(isDiscovery ? discoveryInitialValues?.brand : selectedBrandItems?.[0] || selectedProductItems?.[0]) && (
                              <><strong>Entity:</strong> {isDiscovery ? discoveryInitialValues?.brand : selectedBrandItems?.[0] || selectedProductItems?.[0]} |{" "}</>
                            )}
                            {(isDiscovery ? discoveryInitialValues?.category : selectedCategory?.[0]) && (
                              <><strong>Type:</strong> {mapLabel(selectedOptionShow)} |{" "}</>
                            )}
                            {(isDiscovery ? discoveryInitialValues?.category : selectedCategory?.[0]) && (
                              <><strong>Category:</strong> {isDiscovery ? discoveryInitialValues?.category : selectedCategory?.[0]}</>
                            )}
                          </p>

                          <p style={{ margin: '2px 0' }}>
                            {(isDiscovery ? discoveryInitialValues?.persona : selectedPersona?.[0]) && (
                              <><strong>Persona:</strong> {isDiscovery ? discoveryInitialValues?.persona : selectedPersona?.[0]} |{" "}</>
                            )}
                            {(isDiscovery ? discoveryInitialValues?.geography : selectedGeographyItems?.[0]) && (
                              <><strong>Geography:</strong> {isDiscovery ? discoveryInitialValues?.geography : selectedGeographyItems?.[0]} |{" "}</>
                            )}
                            {(isDiscovery ? discoveryInitialValues?.market : selectedMarketItems?.[0]) && (
                              <><strong>Market:</strong> {isDiscovery ? discoveryInitialValues?.market : selectedMarketItems?.[0]}</>
                            )}
                          </p>

                          <p style={{ margin: '2px 0' }}>
                            <strong>Filter:</strong>{" "}
                            {pdfFilterOption.charAt(0).toUpperCase() + pdfFilterOption.slice(1)}
                          </p>
                        </div>
                      </div>

                      {/* PDF Tables */}
                      {getFilteredTables().map((table, index) => (
                        <div
                          key={table.id}
                          style={{
                            marginBottom: "6px",
                            pageBreakInside: index === 0 ? "auto" : "avoid",
                            breakInside: index === 0 ? "auto" : "avoid",
                          }}
                        >
                          <TableWrapper
                            {...table}
                            isFirstPdfTable={index === 0}
                            loading={false}
                            minWidth="100%"
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

              </>
            )}
          </div>
        </>

      </div>

      {/* Conversations HTML Reporting Modal */}
      {reportingModalOpen && (() => {
        const _entity   = isDiscovery ? discoveryInitialValues?.brand : (selectedBrandItems?.[0] || selectedProductItems?.[0]);
        const _type     = isDiscovery ? discoveryType : (selectedOptionShow === "Product" ? "product" : "brand");
        const _category = isDiscovery ? discoveryInitialValues?.category : selectedCategory?.[0];
        const _persona  = isDiscovery ? discoveryInitialValues?.persona  : selectedPersona?.[0];
        const _market   = isDiscovery ? discoveryInitialValues?.market   : selectedMarketItems?.[0];
        const _geo      = isDiscovery ? discoveryInitialValues?.geography : selectedGeographyItems?.[0];
        const _sites    = isDiscovery ? discoveryInitialValues?.siteSuggestions : selectedSiteSuggestions;

        const metadata = {
          entity: _entity || currentEntity,
          type: _type,
          queryType: tableFilter,
          ...(_category && { category: _category }),
          ...(_persona  && { persona: _persona }),
          ...(_market   && { market: _market }),
          ...(_geo      && { geography: _geo }),
          ...(_sites?.length > 0 && { siteSuggestions: _sites }),
        };

        const _entityLabel = _type === 'product' ? 'product' : 'brand';
        const _entityName  = metadata.entity;
        const _cat         = _category || 'the category';

        const _paramLine = [
          _persona && `Persona: ${_persona}`,
          _market  && `Market: ${_market}`,
          _geo     && `Geography: ${_geo}`,
        ].filter(Boolean).join(' | ');

        const description = [
          `Consumer conversation intelligence for ${_entityLabel} '${_entityName}' within the '${_cat}' category.`,
          `This captures what end-consumers say online about '${_entityName}' as a ${_entityLabel} in '${_cat}' — not about the ${_entityLabel} in isolation.`,
          _paramLine || null,
          `Data scope: this dataset may contain ${_entityLabel}-specific data, category-level data, or both, depending on what was queried.`,
          ``,
          `STRUCTURE`,
          `---------`,
          `The data object has multiple topic modules (discussionTopics, keyQuestions, purchaseBarriers,`,
          `purchaseEnablers, customerNeeds, customerPainPoints, customerEmergingTrends, customerComplaints,`,
          `customerPraises, purchaseJourneyQuestions). Most modules carry both ${_entityLabel} and category data;`,
          `customerComplaints and customerPraises contain ${_entityLabel} data only (no category equivalent).`,
          ``,
          `Within each module:`,
          `  entity_* keys   → data specific to '${_entityName}' as a ${_entityLabel} in '${_cat}'`,
          `  non-prefixed    → data about the '${_cat}' category broadly`,
          `  *_sources       → source URLs with classifications (Own / Competitor / PR Media / Third Party)`,
          `  entityRawSearch / categoryRawSearch → raw text returned by the LLM web-search before formatting`,
          `  rawData         → unprocessed structured LLM output before post-processing`,
          ``,
          `Example (discussionTopics): entity_discussion_topics = what consumers discuss about '${_entityName}' in '${_cat}';`,
          `discussion_topics = what they discuss about '${_cat}' in general.`,
          `Each item in these arrays: { topic, explanation, sources[] }.`,
        ].filter(s => s !== null).join('\n');

        const conversationsJson = {
          metadata,
          description,
          data: discussionTopics,
        };

        return (
          <ConversationsReportingModal
            open={reportingModalOpen}
            onClose={() => setReportingModalOpen(false)}
            onViewInlineOpen={() => {}}
            userId={user?.user_role?.user_id}
            transactionId={String(currentHistoryId)}
            conversationsData={conversationsJson}
          />
        );
      })()}

      {/* PDF Filter Modal */}
      <PdfFilterModal
        open={showPdfFilterModal}
        onClose={handlePdfModalClose}
        pdfFilterOption={pdfFilterOption}
        onFilterChange={handlePdfFilterChange}
        onDownload={handlePdfDownload}
        pdfFilterOptions={pdfFilterOptions}
      />

      <ToastContainer />
    </div>
  );
};

export default Conversations;